import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgHandsoap = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.2092 20.0533H19.7092C20.1513 20.0533 20.5752 19.8777 20.8877 19.5652C21.2003 19.2526 21.3759 18.8287 21.3759 18.3867V10.0533C21.3759 9.6113 21.2003 9.18737 20.8877 8.87481C20.5752 8.56225 20.1513 8.38666 19.7092 8.38666H16.3759C15.9339 8.38666 15.5099 8.56225 15.1974 8.87481C14.8848 9.18737 14.7092 9.6113 14.7092 10.0533V15.0533"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.7092 8.38583H16.3759V6.53167C16.3759 6.36038 16.4439 6.19611 16.5651 6.07499C16.6862 5.95388 16.8504 5.88583 17.0217 5.88583H19.0634C19.2347 5.88583 19.3989 5.95388 19.5201 6.07499C19.6412 6.19611 19.7092 6.36038 19.7092 6.53167V8.38583Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.3759 11.72H14.7092"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.3759 16.72H17.2092"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.62427 17.6967L5.07177 19.655C5.84732 20.2755 6.81103 20.6135 7.80427 20.6133H12.8334C13.0249 20.6133 13.2146 20.5756 13.3915 20.5023C13.5684 20.429 13.7292 20.3216 13.8646 20.1862C14.0001 20.0508 14.1075 19.89 14.1808 19.7131C14.254 19.5361 14.2918 19.3465 14.2918 19.155V19.155C14.2915 18.7683 14.1378 18.3975 13.8644 18.124C13.5909 17.8506 13.2201 17.6969 12.8334 17.6967H9.0651"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.75684 13.3217H5.6735C6.53781 13.322 7.3827 13.578 8.10184 14.0575L9.7685 15.1683C9.92639 15.2632 10.0634 15.3891 10.1712 15.5385C10.279 15.6878 10.3554 15.8575 10.3958 16.0372C10.4361 16.2169 10.4396 16.403 10.406 16.5841C10.3724 16.7652 10.3023 16.9376 10.2002 17.0908V17.0908C10.0161 17.3667 9.73767 17.5659 9.41715 17.651C9.09663 17.7362 8.75606 17.7014 8.45934 17.5533L6.27017 16.2383"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2091 9.63667C12.2091 10.1892 11.9897 10.7191 11.599 11.1098C11.2083 11.5005 10.6783 11.72 10.1258 11.72C9.57328 11.72 9.04338 11.5005 8.65267 11.1098C8.26197 10.7191 8.04248 10.1892 8.04248 9.63667C8.04248 8.07417 10.1258 5.47 10.1258 5.47C10.1258 5.47 12.2091 8.07417 12.2091 9.63667Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.0425 3.38666V5.88666"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0425 5.05332L13.415 4.30749C13.5535 4.03072 13.7663 3.79798 14.0296 3.63534C14.2929 3.4727 14.5963 3.38659 14.9058 3.38666H20.5425"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgHandsoap.displayName = 'SvgHandsoap';
export default SvgHandsoap;
